import React from 'react';
import { Input, Tooltip, Button, Checkbox } from 'antd/lib';
import { Form } from '@ant-design/compatible';
import * as Icons from '@ant-design/icons';

import FormVentaSello from '../../formularios/FormVentaSello';

// import SelectorModelo from './SelectorModelo'
const FormItem = Form.Item;
const { TextArea } = Input;

class FormAutorizacionOtros extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      confirmDirty: false,
      autoCompleteResult: [],
      existeVenta: false,
      autorizacion: '',
      enteReceptor: '',
    };
  }

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        // console.log("Received values of form: ", values);
        this.props.onSubmit({
          autorizacion: values.autorizacion,
          ente_receptor: values.ente_receptor,
          existeVenta: this.state.existeVenta,
        });
      }
    });
  };

  onFinalizar = (ventaSinStock, detalles, datosPonset, extras) => {
    let datos = {
      autorizacion: this.props.form.getFieldValue('autorizacion'),
      ente_receptor: this.props.form.getFieldValue('ente_receptor'),
      existeVenta: this.state.existeVenta,
      detalles,
      datosPonset,
      extras,
    };
    // console.log('DATOS: ', datos);

    this.props.onSubmit(datos, ventaSinStock);
  };

  onFinalizarMP = (ventaSinStock, detalles, datosMP, extras) => {
    const datos = {
      autorizacion: this.props.form.getFieldValue('autorizacion'),
      ente_receptor: this.props.form.getFieldValue('ente_receptor'),
      existeVenta: this.state.existeVenta,
      detalles,
      datosMP,
      extras,
    };
    this.props.onSubmit(datos, ventaSinStock);
  };

  handleConfirmBlur = e => {
    const value = e.target.value;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  };

  checkConfirm = (rule, value, callback) => {
    const form = this.props.form;
    if (value && this.state.confirmDirty) {
      form.validateFields(['confirm'], { force: true });
    }
    callback();
  };

  handleAutorizacionChange = e => {
    this.setState({
      autorizacion: e.target.value,
    });
  };

  handleEnteChange = e => {
    this.setState({
      enteReceptor: e.target.value,
    });
  };

  onChangeCheckbox = e => {
    // console.log(`checked = ${e.target.checked}`);
    this.setState({
      ...this.state,
      existeVenta: e.target.checked,
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };

    return (
      <div>
        <h1 className="tituloForm">Datos de la Autorizacion</h1>

        <Form
          onSubmit={this.handleSubmit}
          style={{ marginTop: 50, marginRight: 40 }}
        >
          <FormItem
            {...formItemLayout}
            label={
              <span>
                Autorizacion
                <Tooltip title="Lo que se quiere autorizar ">
                  <Icons.QuestionCircleOutlined />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator('autorizacion', {
              rules: [
                {
                  required: true,
                  message: 'Por favor, ingresar el texto a autorizar!',
                  whitespace: true,
                },
              ],
            })(<TextArea rows={6} onChange={this.handleAutorizacionChange} />)}
          </FormItem>

          <FormItem
            {...formItemLayout}
            label={
              <span>
                Ente Receptor
                <Tooltip title="Para quien será la declaracion ">
                  <Icons.QuestionCircleOutlined />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator('ente_receptor', {
              rules: [
                {
                  required: true,
                  message: 'Por favor, ingresar el ente receptor!',
                  whitespace: true,
                },
              ],
            })(<Input onChange={this.handleEnteChange} />)}
          </FormItem>

          {this.props.config.creacion && (
            <FormItem>
              <Checkbox
                style={{ marginLeft: '30%' }}
                onChange={this.onChangeCheckbox}
                disabled={
                  this.state.autorizacion === '' ||
                  this.state.enteReceptor === ''
                }
              >
                Computar Venta
              </Checkbox>
            </FormItem>
          )}

          {this.state.existeVenta && (
            <div>
              <hr />
              <FormVentaSello
                opcionRender={1}
                organismo={this.props.organismo}
                onFinalizar={(detalles, datosPonset, extras) =>
                  this.onFinalizar(false, detalles, datosPonset, extras)
                }
                crearVentaCompleta={(detalles, datosPonset, extras) =>
                  this.onFinalizar(true, detalles, datosPonset, extras)
                }
                crearVentaMercadoPago={(detalles, datosMP, extras) =>
                  this.setState({ loading: true }, () =>
                    this.onFinalizarMP(true, detalles, datosMP, extras)
                  )
                }
                tramite={'AUTORIZACIONES OTRAS'}
              />
              <hr />
            </div>
          )}

          <FormItem {...tailFormItemLayout}>
            <Button
              type="primary"
              htmlType="submit"
              disabled={
                this.state.autorizacion === '' || this.state.enteReceptor === ''
              }
            >
              <Icons.SolutionOutlined />
              Exento
            </Button>
          </FormItem>
        </Form>
      </div>
    );
  }
}

export default Form.create({
  mapPropsToFields(props) {
    return {
      autorizacion: Form.createFormField({
        value: props.datos ? props.datos.autorizacion : '',
      }),
      ente_receptor: Form.createFormField({
        value: props.datos ? props.datos.ente_receptor : '',
      }),
    };
  },
})(FormAutorizacionOtros);
